export default __webpack_public_path__ + "static/metaverso-cosa-rappresenta-per-gli-sviluppatori-orangeloop-7a5864356d677f5567279e52acf8783e.jpg";